<template>
  <!-- 导航菜单 -->
  <el-col :md="14" :xs="24" class="hidden-xs-only">
    <div class="collapse">
      <el-menu mode="horizontal" :default-active="activeIndex" :router="true">
        <el-menu-item
          v-for="item in menuItem"
          :key="item.index"
          :index="item.isExternal ? '' : item.to"
          @click="handleMenuItemClick(item)"
        >
          <a>{{ item.text }}</a>
        </el-menu-item>
      </el-menu>
    </div>
  </el-col>
</template>

<script>
import { ref } from 'vue'
import { useRoute } from 'vue-router/composables'
export default {
  props: {
    menuItem: {
      type: Array,
      default: () => []
    }
  },
  setup (props) {
    const route = useRoute()
    const activeIndex = ref(route.path)
    const handleMenuItemClick = (item) => {
      if (item.isExternal) {
        window.open(item.to, '_blank')
        return false
      }
      return true
    }
    return {
      activeIndex,
      handleMenuItemClick
    }
  }
}
</script>

<style lang="scss" scoped>
.el-col {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}
.collapse {
  padding-right: 15px;
  padding-left: 15px;
  overflow-x: visible;
  -webkit-overflow-scrolling: touch;
  border-top: 1px solid transparent;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
  background-color: transparent;

  @media (min-width: 768px) {
    display: block !important;
    height: auto !important;
    padding-bottom: 0;
    overflow: visible !important;
    width: auto;
    border-top: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .el-menu {
    margin-top: 10px;
    background-color: transparent !important;
    display: block;
    list-style-type: disc;
    margin-block-start: 10px;
    margin-block-end: 10px;
    unicode-bidi: isolate;

    .el-menu-item {
      opacity: 1;
      padding: 15px;
      line-height: 15px;
      background-color: transparent !important;

      a {
        text-decoration: none;
        font-size: 15px;
        color: #e9e5e5 !important;
        font-weight: bolder;
        line-height: 20px;
      }
    }
    .el-menu-item:hover {
      a {
        opacity: 1 !important;
        color: #5ef8ff !important;
      }
    }
  }
  .el-menu.el-menu--horizontal {
    border-bottom: none !important;

    .el-menu-item.is-active {
      border-bottom: 2px solid #409eff !important; // 恢复默认的激活菜单项下划线
    }
  }
}
</style>
